import { render, staticRenderFns } from "./VStyledCheckbox.vue?vue&type=template&id=62580f33&scoped=true"
import script from "./VStyledCheckbox.vue?vue&type=script&lang=js"
export * from "./VStyledCheckbox.vue?vue&type=script&lang=js"
import style0 from "./VStyledCheckbox.vue?vue&type=style&index=0&id=62580f33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62580f33",
  null
  
)

export default component.exports